import { AccesoryService } from "../../../services/accesory.service";
import { MovileService } from "../../../services/movile.service";
import { ProductService } from "../../../services/product.service";
import {
  filterProductAccesoriesByBarCode,
  filterCashCardByBarCode,
  filterChipsByLote,
  filterMovilesByBarCode,
} from "../../../_utils/utils";
import { read, utils } from "xlsx";

export const chipsAvailableByCategory = async (chipsArray) => {
  let availableInStore = [];
  let availableInSite = [];
  /** Filter all chips and recover just those who had the same chip category */
  try {
    for (const [index, { chipCatalogueId }] of chipsArray.entries()) {
      const chipProperties = { inDistribution: false, chipCatalogueId };
      /** Recover chips counter in Store */
      const { data } = await ProductService.countChipsInStore(chipProperties);
      /** Recover chips counter in Sites */
      const result = await ProductService.countChipsInSites(chipProperties);
      availableInStore.push({ index, availables: data });
      availableInSite.push({ index, availables: result.data });
    }
    return { availableInStore, availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const movilesAvailableByBarCode = async (movilesFiltered) => {
  let availableInStore = [];
  let availableInSite = [];
  try {
    for (const [
      index,
      { brand, model, barCode },
    ] of movilesFiltered.entries()) {
      const movileProperties = { brand, model, inDistribution: false, barCode };
      /** Recover accesory counter in Store */
      const { data } = await ProductService.countMovilesInStore(
        movileProperties
      );
      /** Recover accesory counter in Sites */
      const result = await ProductService.countMovilesInSites(movileProperties);
      availableInStore.push({ index, availables: data });
      availableInSite.push({ index, availables: result.data });
    }
    // console.log('availableInStore', availableInStore);
    // console.log('availableInSite', availableInSite);
    return { availableInStore, availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const productAccesoriesAvailable = async (productAccesoryFiltered) => {
  console.log("accesoriesFiltered", productAccesoryFiltered);
  const { brand, model, barCode } = productAccesoryFiltered;
  let availableInStore = [];
  let availableInSite = [];
  const accesoryProperties = { brand, model, inDistribution: false, barCode };

  try {
    /** Recover accesory counter in Store */
    const { data } = await ProductService.countAccesoriesInStore(
      accesoryProperties
    );
    /** Recover accesory counter in Sites */
    const result = await ProductService.countAccesoriesInSites(
      accesoryProperties
    );
    availableInStore.push({ index: 0, availables: data });
    availableInSite.push({ index: 0, availables: result.data });

    return { availableInStore, availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const accesoriesAvailableByBarCode = async (accesoriesFiltered) => {
  console.log("accesoriesFiltered", accesoriesFiltered);
  let availableInStore = [];
  let availableInSite = [];
  try {
    for (const [
      index,
      { brand, model, barCode },
    ] of accesoriesFiltered.entries()) {
      const accesoryProperties = {
        brand,
        model,
        inDistribution: false,
        barCode,
      };
      /** Recover accesory counter in Store */
      const { data } = await ProductService.countAccesoriesInStore(
        accesoryProperties
      );
      /** Recover accesory counter in Sites */
      const result = await ProductService.countAccesoriesInSites(
        accesoryProperties
      );
      availableInStore.push({ index, availables: data });
      availableInSite.push({ index, availables: result.data });
    }
    return { availableInStore, availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const accesoriesAvailable = async (accesoriesArray, page, limit) => {
  let availableInStore = [];
  let availableInSite = [];
  try {
    console.log(
      "filter values ",
      filterProductAccesoriesByBarCode(accesoriesArray)
    );
    /** Filter all accesories and recover just those who had the same bar code */
    for (const [index, product] of filterProductAccesoriesByBarCode(
      accesoriesArray
    ).entries()) {
      const {
        accesory: { brand, model, barCode },
      } = product;
      const accesoryProperties = {
        brand,
        model,
        inDistribution: false,
        barCode,
      };
      /** Recover accesory counter in Store */
      const { data } = await ProductService.countAccesoriesInStore(
        accesoryProperties
      );
      /** Recover accesory counter in Sites */
      const result = await ProductService.countAccesoriesInSites(
        accesoryProperties
      );
      availableInStore.push({ index, availables: data });
      availableInSite.push({ index, availables: result.data });
    }
    return { availableInStore, availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const cashCardsAvailable = async (cashcardArray) => {
  let availableInStore = [];
  let availableInSite = [];
  try {
    /** Filter all cashCard and recover just those who had the same bar code */
    for (const [index, product] of filterCashCardByBarCode(
      cashcardArray
    ).entries()) {
      const {
        cash_card: { cardCatalogueId },
      } = product;
      const cashCardProperties = { cardCatalogueId, inDistribution: false };
      /** Recover cash card counter in Store */
      const { data } = await ProductService.countCashCardsInStore(
        cashCardProperties
      );
      /** Recover cash card counter in Sites */
      const result = await ProductService.countCashCardsInSite(
        cashCardProperties
      );
      availableInStore.push({ index, availables: data });
      availableInSite.push({ index, availables: result.data });
    }
    return { availableInStore, availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const cashCardsAvailableInSite = async (cashCardArray) => {
  let availableInSite = [];
  /** Filter all cashCard and recover just
   * those who had the same bar code in the siteId
   * */
  try {
    for (const [index, product] of filterCashCardByBarCode(
      cashCardArray
    ).entries()) {
      const {
        cash_card: { siteId, cardCatalogueId },
      } = product;
      const cashCardProperties = {
        siteId,
        cardCatalogueId,
        inDistribution: false,
        productSold: 0,
      };
      /** Recover cash card counter in single site */
      const { data } = await ProductService.countCashCardsInSingleSite(
        cashCardProperties
      );
      console.log("data counter", data);
      availableInSite.push({ index, availables: data });
    }
    return { availableInSite };
  } catch (error) {
    console.log("error", error);
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const getAccesoriesByFilters = async (params, inSites) => {
  let result = {};
  try {
    if (inSites) {
      const {
        data: { accesories, count },
      } = await AccesoryService.getAccesoriesBySitePaginated(params);
      result = { accesories, count };
    } else {
      const {
        data: { accesories, count },
      } = await AccesoryService.getAccesoriesBySitesAndStorePaginated(params);
      result = { accesories, count };
    }
    return result;
  } catch (error) {
    throw error;
  }
};

export const getMovilesByFilters = async (params) => {
  try {
    const {
      data: { moviles, count },
    } = await MovileService.getMovileByParamsWithPagination(params);
    return { moviles, count };
  } catch (error) {
    throw error;
  }
};

export const searchAccesoryByBarCode = async (queryParams) => {
  try {
    const { data } = await ProductService.getProductByAccesoriesWithParams(
      queryParams
    );
    if (data.length) {
      const result = {
        accesory: data[0].accesory,
        totalAccesories: data.length,
      };
      return result;
    } else {
      throw queryParams;
    }
  } catch (error) {
    throw error;
  }
};

export const searchMovileByBarCode = async (queryParams) => {
  try {
    const { data } = await ProductService.getProductByMovilesWithParams(
      queryParams
    );
    if (data.length) {
      const result = {
        movile: data[0].movile,
        totalMoviles: data.length,
      };
      console.log("result", result);
      return result;
    } else {
      const error = {
        movileNotFoundMsg: `No se encontró equipo móvil asociado al código de barras ${queryParams.barCode}`,
      };
      throw error;
    }
  } catch (error) {
    throw error;
  }
};

export const searchMovileByImei = async (imei) => {
  console.log("imei to search", imei);
  try {
    const { data } = await ProductService.getMovileProductByImei(imei);
    if (data?.movile) {
      return data.movile;
    } else {
      const error = { imei };
      throw error;
    }
  } catch (error) {
    throw error;
  }
};

export const movilesAvailableInSite = async (movilesArray) => {
  let availableInSite = [];
  /** Filter all moviles and recover just those who had the same bar code */
  try {
    for (const [
      index,
      { brand, model, siteId, barCode },
    ] of movilesArray.entries()) {
      const movileProps = {
        brand,
        model,
        barCode,
        siteId,
        inDistribution: 0,
        productSold: 0,
      };
      /** Recover available moviles in specific site */
      const { data } = await ProductService.countMovilesInSingleSite(
        movileProps
      );
      // console.log("movilesAvailableInSite data", data);
      availableInSite.push({ index, availables: data });
    }
    return { availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const allAccesoriessAvailableInSite = async (productAccesoriesArray) => {
  let availableInSite = [];
  /** Filter all accesories and recover just those who had the same bar code */
  try {
    for (const [
      index,
      {
        accesory: { brand, model, siteId, barCode, subcategoryTypeId },
      },
    ] of productAccesoriesArray.entries()) {
      const accesoryProps = {
        brand,
        model,
        siteId,
        barCode,
        inDistribution: 0,
        subcategoryTypeId,
        productSold: 0,
      };
      /** Recover available accesories in specific site */
      const { data } = await ProductService.countAccesoriesSingleSite(
        accesoryProps
      );
      availableInSite.push({ index, availables: data });
    }
    return { availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const accesoriessAvailableInSite = async (accesoriesArray) => {
  let availableInSite = [];
  /** Filter all accesories and recover just those who had the same bar code */
  try {
    for (const [
      index,
      { brand, model, siteId, barCode, subcategoryTypeId },
    ] of accesoriesArray.entries()) {
      const accesoryProps = {
        brand,
        model,
        siteId,
        barCode,
        inDistribution: 0,
        subcategoryTypeId,
        productSold: 0,
      };
      /** Recover available accesories in specific site */
      const { data } = await ProductService.countAccesoriesSingleSite(
        accesoryProps
      );
      availableInSite.push({ index, availables: data });
    }
    return { availableInSite };
  } catch (error) {
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const chipsAvailableInSite = async (chipsArray) => {
  let availableInSite = [];
  /** Filter all chips and recover just those who had the same bar code */
  try {
    for (const [index, product] of filterChipsByLote(chipsArray).entries()) {
      const {
        chip: { lote, siteId },
      } = product;

      /** Recover chips counter in single site */
      const { data } = await ProductService.countChipsSingleSite({
        lote,
        siteId,
        inDistribution: 0,
        productSold: 0,
      });
      availableInSite.push({ index, availables: data });
    }
    return { availableInSite };
  } catch (error) {
    console.log("error", error);
    const errorObj = { msg: "Error al recuperar disponibilidad productos" };
    throw errorObj;
  }
};

export const addAvailabilityToProducts = (
  productArray,
  availablesInStore,
  availablesInSite
) => {
  const copy = [...productArray];
  productArray.forEach((product, index) => {
    copy[index] = {
      ...copy[index],
      availablesInStore: availablesInStore[index].availables,
      availablesInSite: availablesInSite[index].availables,
    };
  });
  return copy;
};

export const addAvailabilityToProductsInSite = (
  productArray,
  availablesInSite
) => {
  const copy = [...productArray];
  productArray.forEach((_, index) => {
    copy[index] = {
      ...copy[index],
      availablesInSite:
        availablesInSite[index].quantity || availablesInSite[index].availables,
    };
  });
  return copy;
};

export const validateOriginStore = (arrayProduct, type) => {
  switch (type) {
    case "movile":
      return arrayProduct.every((item) => item.movile.siteId === 1);
    case "accesory":
      return arrayProduct.every((item) => item.accesory.siteId === 1);
    case "chip":
      return arrayProduct.every((item) => item.chip.siteId === 1);
    case "cashCard":
      return arrayProduct.every((item) => item.cash_card.siteId === 1);
    default:
      break;
  }
};

export const validateOriginStoreAndDistribution = (arrayProduct, type) => {
  switch (type) {
    case "movile":
      return arrayProduct.every(
        (item) => item.movile.siteId === 1 && !item.movile.inDistribution
      );
    case "accesory":
      return arrayProduct.every(
        (item) => item.accesory.siteId === 1 && !item.accesory.inDistribution
      );
    case "chip":
      return arrayProduct.every(
        (item) => item.chip.siteId === 1 && !item.chip.inDistribution
      );
    case "cashCard":
      return arrayProduct.every(
        (item) => item.cash_card.siteId === 1 && !item.cash_card.inDistribution
      );
    default:
      break;
  }
};

export const getProductInfo = (product) => {
  if (product.movile) {
    return `${product.movile.brand} ${product.movile.model}`;
  }
  if (product.accesory) {
    return `${product.accesory.brand} ${product.accesory.model}`;
  }
  if (product.chip) {
    return `Chip ${product.chip.chip_catalogue?.name}`;
  }
  if (product.cash_card) {
    return `${product.cash_card?.card_catalogue.name}  $${product.cash_card?.card_catalogue.amount}`;
  }
};

export const countItemsIncart = (cart) => {
  const productCounter = {};
  const arrayTest = [];

  if (Object.keys(cart).length) {
    Object.values(cart).forEach((product, i) => {
      if (product.movileId) {
        // console.log("movile Info", productInfo);
        const productInfo = `1|${product.movile.brand} ${product.movile.model}|${product.movile.price}`;
        productCounter[productInfo] = productCounter[productInfo] + 1 || 1;
      }

      if (product.accesoryId) {
        // console.log("accesory info", productInfo);
        const productInfo = `2|${product.accesory.brand} ${product.accesory.model}|${product.accesory.price}`;
        productCounter[productInfo] = productCounter[productInfo] + 1 || 1;
      }

      if (product.cashCardId) {
        // console.log("cashCard info", productInfo);
        const productInfo = `4|${product.cash_card.card_catalogue.name} ${product.cash_card.card_catalogue.amount}|${product.cash_card.card_catalogue.amount}|${product.cash_card.card_catalogue.barCode}`;
        productCounter[productInfo] = productCounter[productInfo] + 1 || 1;
      }

      if (product.balanceTransferId) {
        // console.log("cashCard info", productInfo);
        const productInfo = `5|${product.balance_transfer.balance_catalogue.name}|${product.balance_transfer.amount}`;
        productCounter[productInfo] = productCounter[productInfo] + 1 || 1;
      }
      if (product.phonePlanId) {
        // console.log("cashCard info", productInfo);
        const productInfo = `6|${product.phone_plan.concept}|${product.phone_plan.amount}|${product.phonePlanId}`;
        productCounter[productInfo] = productCounter[productInfo] + 1 || 1;
      }
    });
  }
  Object.entries(productCounter).forEach(([key, value], i) => {
    const [productTypeId, productInfo, price, barCode] = key.split("|");
    if (productTypeId === "4") {
      arrayTest[i] = {
        productInfo,
        units: value,
        productTypeId: productTypeId,
        price,
        barCode,
      };
    } else if (productTypeId === "6") {
      arrayTest[i] = {
        productInfo: `${productInfo.slice(0, 20)}...`,
        units: value,
        productTypeId: productTypeId,
        price,
        id: barCode,
      };
    } else {
      arrayTest[i] = {
        productInfo,
        units: value,
        productTypeId: productTypeId,
        price,
      };
    }
  });
  return arrayTest;
};

export const importExcelFileProduct = (files, productSelected) => {
  let messageResult = {};

  try {
    const objectFile = files[0];
    // console.log("fileName", objectFile?.name);

    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(objectFile);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const workBook = read(bufferArray, { type: "buffer" });
        console.log("sheetName", workBook.SheetNames);
        console.log("productSelected", productSelected);

        // Validate one sheet
        if (workBook.SheetNames.length > 1) {
          messageResult = {
            severity: "warning",
            message: "El archivo tiene mas de una hoja o pestaña",
            isError: true,
          };
        }

        // Validate productSelected movile or accesory
        else if (productSelected > 2) {
          messageResult = {
            severity: "info",
            message:
              "La carga de productos por excel solo esta permitida en Móviles y Accesorios",
            time: 4000,
            isError: true,
          };
        }

        // Validate name 'accesory'  on sheet
        else if (
          productSelected === 2 &&
          workBook.SheetNames[0].toUpperCase() !== "ACCESORIOS"
        ) {
          messageResult = {
            severity: "error",
            message:
              "El nombre de la hoja en el archivo no es correcto, debe de ser 'Accesorios'",
            time: 4000,
            isError: true,
          };
        }

        // Validate name 'moviles'  on sheet
        else if (
          productSelected === 1 &&
          workBook.SheetNames[0].toUpperCase() !== "MOVILES"
        ) {
          messageResult = {
            severity: "error",
            message:
              "El nombre de la hoja en el archivo no es correcto, debe de ser 'Moviles'",
            time: 4000,
            isError: true,
          };
        }

        // Everything is correct
        else {
          const workBookName = workBook.SheetNames[0];
          const workSheet = workBook.Sheets[workBookName];
          const dataArray = utils.sheet_to_json(workSheet);

          const validateRows = validateExcelRowFiles(
            dataArray,
            productSelected
          );
          console.log("validateRows", validateRows);
          messageResult = validateRows;
        }

        resolve(messageResult);
        console.log("continuueeee");
      };

      fileReader.onerror = reject;
    });
  } catch (error) {
    messageResult = {
      severity: "error",
      message: error,
      time: 3000,
      isError: true,
    };
    return messageResult;
  }
};

const validateExcelRowFiles = (dataArray, productSelected) => {
  let messageResult = {};
  // moviles
  if (productSelected === 1) {
    const lengthError = dataArray.some((row) => Object.keys(row).length !== 13);
    const filledError = dataArray.some((row) => {
      return row.inDistribution !== 0 || row.siteId !== 1;
    });

    let imeis = new Set(dataArray);
    const imeiRepeated = dataArray.filter((row) => {
      if (!imeis.has(row.imeiCode)) {
        imeis.add(row.imeiCode);
        return true;
      }
      return false;
    });
    console.log("imeiRepeated", imeiRepeated);

    if (lengthError || filledError) {
      messageResult = {
        severity: "error",
        message: lengthError
          ? "Verificar archivo, alguno de los campos en una fila esta vacio."
          : "Alguna fila tiene incorrecto el campo 'inDistribution' o 'siteId'.",
        time: 4000,
        isError: true,
      };
    } else if (imeiRepeated.length !== dataArray.length) {
      messageResult = {
        severity: "error",
        message: "Verifical archivo, un IMEI se encuentra repetido",
        time: 4000,
        isError: true,
      };
    } else {
      messageResult = {
        severity: "success",
        message: "Excel de moviles importado exitosamente",
        time: 4000,
        isError: false,
        dataArray,
      };
    }
  } else {
    const lengthError = dataArray.some((row) => Object.keys(row).length !== 11);
    const filledError = dataArray.some((row) => {
      return row.inDistribution !== 0 || row.siteId !== 1;
    });

    if (lengthError || filledError) {
      messageResult = {
        severity: "error",
        message: lengthError
          ? "Verificar archivo, alguno de los campos en una fila esta vacio"
          : "Alguna fila tiene incorrecto el campo 'inDistribution' o 'siteId'",
        time: 4000,
        isError: true,
      };
    } else {
      messageResult = {
        severity: "success",
        message: "Excel de accesorios importado exitosamente",
        time: 4000,
        isError: false,
        dataArray,
      };
    }
  }

  return messageResult;
};
